import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteCompanyAddressModel } from 'src/app/models/companyAddress/company-address-model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { CompanyAddressService } from 'src/app/services/company-address.service';

@Component({
  selector: 'app-company-address-delete',
  templateUrl: './company-address-delete.component.html',
  styleUrls: ['./company-address-delete.component.css']
})
export class CompanyAddressDeleteComponent implements OnInit {

deleteAddress: DeleteCompanyAddressModel = new DeleteCompanyAddressModel();
Loader: boolean = false;

  constructor(private companyAdress: CompanyAddressService,private modalService: NgbModal,private alertify: AlertifyService) { }

  ngOnInit() {
    this.companyAdress.getCustomerAddressId.subscribe((id: string) => {
      this.deleteAddress.Id = +id;
    });
  }
  
  DeleteAddress() {
    this.Loader = true;
    this.companyAdress.DeleteAddress(this.deleteAddress)
    .subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.alertify.success(responseBody.responseMessage);
        this.modalService.dismissAll();
        this.Loader = false;
      } else {
        this.Loader = false
      }
    })
  }

  onCancel() {
    this.modalService.dismissAll();
  }
}
